import type { CategoryBreakdown } from '@apply/lending-limits';
import { RentalRows } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/rows/RentalRows';
import { IRentalTableRow } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/interfaces/IRentalTableRow';
import { combineRows, detailRow, fromBucket } from './shared';

/** Rental grid rows — the two rental products, totalled as DSCR. */
export function toRentalRows(breakdown: CategoryBreakdown): IRentalTableRow[] {
    const rental = fromBucket(breakdown.buckets.rental);
    const buildFixRent = fromBucket(breakdown.buckets.buildFixRent);

    return [
        { summaryItemType: RentalRows.Rental, ...detailRow(rental) },
        { summaryItemType: RentalRows.BuildFixRent, ...detailRow(buildFixRent) },
        { summaryItemType: RentalRows.DSCR, ...detailRow(combineRows([rental, buildFixRent])) },
    ];
}
